import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Card from '../../components/common/Card/Card';
import StockInfo from '../../components/financial/StockInfo/StockInfo';
import StockChart from '../../components/charts/StockChart/StockChart';
import FinancialMetrics from '../../components/financial/FinancialMetrics/FinancialMetrics';
import NewsFeed from '../../components/financial/NewsFeed/NewsFeed';
import CompanyDescription from '../../components/financial/CompanyDescription';
import MergedFinancialData from '../../components/financial/MergedFinancialData';
import './Dashboard.css';

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedSymbol, setSelectedSymbol] = useState('AAPL');
  const [searchQuery, setSearchQuery] = useState('');

  // Handle URL parameters for stock symbol
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const symbolFromUrl = params.get('symbol');
    if (symbolFromUrl && symbolFromUrl.trim()) {
      const newSymbol = symbolFromUrl.trim().toUpperCase();
      if (newSymbol !== selectedSymbol) {
        setSelectedSymbol(newSymbol);
      }
    }
  }, [location.search, selectedSymbol]);

  const handleSymbolChange = (symbol) => {
    setSelectedSymbol(symbol);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const newSymbol = searchQuery.trim().toUpperCase();
      setSelectedSymbol(newSymbol);
      setSearchQuery('');
      
      // Update URL to reflect the searched stock symbol
      navigate(`/dashboard?symbol=${encodeURIComponent(newSymbol)}`);
    }
  };

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div className="dashboard-header-left">
          <div className="search-container">
            <form onSubmit={handleSearch} className="search-form-dashboard">
              <input
                type="text"
                placeholder="Search stock symbol (e.g., AAPL, MSFT)"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
              />
              <button type="submit" className="search-button">
                🔍
              </button>
            </form>
          </div>
        </div>
        <div className="dashboard-header-right">
          <h1 className="dashboard-title">Stock Dashboard</h1>
          <p className="dashboard-subtitle">
            Comprehensive analysis and insights for {selectedSymbol}
          </p>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="dashboard-main">
          {/* 1. Chart at the top (full width) */}
          <Card className="stock-chart-card">
            <StockChart symbol={selectedSymbol} showControls={false} enableInteractions={false} showShortMAs={false} showLongMA={false} showRefreshInfo={true} showTimeframes={true} />
          </Card>

          {/* 2. About Company section moved up */}
          <Card className="company-description-card">
            <CompanyDescription symbol={selectedSymbol} />
          </Card>

          {/* 3. Merged Financial Profile & Metrics in single box */}
          <Card className="merged-financial-card">
            <MergedFinancialData symbol={selectedSymbol} />
          </Card>
        </div>

        <div className="dashboard-sidebar">
          <Card className="news-feed-card">
            <NewsFeed symbol={selectedSymbol} />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 